import { URLRegex } from "@/utils/formHelper";
import { TFunction } from "i18next";

const preventXSS = (value: string, errorMessage: string) => {
  const scriptPattern = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  const onEventPattern = /\bon\w+\s*=/gi;
  const jsUrlPattern = /javascript:/gi;
  const htmlTagPattern = /<\s*[a-z][a-z0-9]*(\s+[^>]*)?>/gi;

  if (
    scriptPattern.test(value) ||
    onEventPattern.test(value) ||
    jsUrlPattern.test(value) ||
    htmlTagPattern.test(value)
  ) {
    return errorMessage;
  }

  return true;
};

const SOCIAL_PLATFORMS = [
  "facebook",
  "instagram",
  "threads",
  "tiktok",
  "x",
  "reddit",
  "nextdoor",
  "tumblr",
  "behance",
  "bluesky",
  "mastodon",
  "vkontakte",
  "facebookMessenger",
  "whatsapp",
  "microsoftTeams",
  "discord",
  "skype",
  "telegram",
  "line",
  "snapchat",
  "youtube",
  "spotify",
  "appleMusic",
  "twitch",
  "soundcloud",
  "vimeo",
  "onlyfans",
  "flickr",
  "dribbble",
  "pinterest",
  "linkedin",
  "github",
  "quora",
  "xing",
  "googleReviews",
  "yelp",
  "tripadvisor",
  "uberEats",
  "web",
];

export const qrListPickerValidations = (messageKey: string, t: TFunction) => {
  const required = {
    required: {
      value: true,
      message: t("required_message"),
    },
  };

  const commonUrlPattern = {
    pattern: {
      value: new RegExp(URLRegex),
      message: t(messageKey),
    },
  };

  const standardValidations = SOCIAL_PLATFORMS.map((name) => ({
    name,
    rules: { ...required, ...commonUrlPattern },
  }));

  return [
    ...standardValidations,
    {
      name: "apple",
      rules: {
        ...required,
        pattern: {
          value: new RegExp(
            "^(?:https?:\\/\\/(?:www\\.)?|https:(?:\\/\\/)?)?(www\\.)?(apps.apple\\.com)\\/.+$"
          ),
          message: t(messageKey),
        },
      },
    },
    {
      name: "google",
      rules: {
        ...required,
        pattern: {
          value: new RegExp(
            "^(?:https?:\\/\\/(?:www\\.)?|https:(?:\\/\\/)?)?(www\\.)?(play.google\\.com)\\/.+$"
          ),
          message: t(messageKey),
        },
      },
    },
    {
      name: "amazon",
      rules: {
        ...required,
        pattern: {
          value: new RegExp(
            "^(?:https?:\\/\\/(?:www\\.)?|https:(?:\\/\\/)?)?(www\\.)?(amazon\\.com)\\/.+$"
          ),
          message: t(messageKey),
        },
      },
    },
  ];
};

export const qrNameValidation = (t: TFunction) => {
  return {
    name: "qrName",
    rules: {
      maxLength: {
        value: 100,
        message: t("max_length", {
          maxLength: 100,
        }),
      },
      validate: (value) => preventXSS(value, t("no_xss")),
    },
  };
};
